export { BONUS_BY_PRODUCT_TABLE_PT_BR } from "./bonus-by-product-table-pt-br";
export { BONUS_BY_PRODUCT_TABLE_ES_MX } from "./bonus-by-product-table-es-mx";
export { BONUS_BY_PRODUCT_TABLE_EN_US } from "./bonus-by-product-table-en-us";
export { BONUS_BY_PRODUCT_TABLE_FR_FR } from "./bonus-by-product-table-fr-fr";

export type { BonusByProductTableTranslations } from "./bonus-by-product-table-pt-br";
